export class BitfinexLoan {
  maxNotionalLoanSizeInUSD: number;
  currentNotionalLoanSizeInUSD: number;
  maxActiveLoanSizeInUSD: number;
  currentActiveLoanSizeInUSD: number;
  minEquityInUSD: number;
  currentEquityInUSD: number;
}
